export const initialValues = {
  allCheck: '',
  encoding: '',
  allColumns: '',
  targetColumn: '',
  number_of_categories: '',
  question_option: ''
};
